import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { api, dt, ROLE_LABEL } from "@/lib/api";
import { PageHeader, Pager } from "@/components/tam/ui";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const ALERT = ["copy_attempt", "print_attempt", "screenshot_attempt", "devtools_attempt", "login_failed"];

export default function AuditLog() {
  const [q, setQ] = useState("");
  const [action, setAction] = useState("");
  const [page, setPage] = useState(1);
  const [data, setData] = useState({ items: [], total: 0, page: 1, pages: 1, actions: [] });

  useEffect(() => {
    const t = setTimeout(() => api.get("/audit", { params: { q, action, page } }).then((r) => setData(r.data)), 300);
    return () => clearTimeout(t);
  }, [q, action, page]);

  return (
    <div data-testid="audit-page">
      <PageHeader title="Audit log" subtitle="Immutable record of every sign-in, view, change, task and blocked copy/print attempt" />
      <div className="flex flex-col sm:flex-row gap-3 mb-5">
        <div className="relative flex-1">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <Input value={q} onChange={(e) => { setQ(e.target.value); setPage(1); }} placeholder="Search user, action or detail…" className="pl-9 bg-white" data-testid="audit-search-input" />
        </div>
        <Select value={action || "all"} onValueChange={(v) => { setAction(v === "all" ? "" : v); setPage(1); }}>
          <SelectTrigger className="sm:w-56 bg-white" data-testid="audit-action-filter"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="all">All actions</SelectItem>{data.actions.map((a) => <SelectItem key={a} value={a}>{a}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div className="bg-white border border-slate-200 rounded-md overflow-x-auto">
        <table className="w-full text-xs min-w-[900px] font-mono" data-testid="audit-table">
          <thead className="bg-slate-50 uppercase tracking-wider text-slate-500 text-left">
            <tr><th className="px-4 py-3">Timestamp</th><th className="px-4 py-3">User</th><th className="px-4 py-3">Role</th><th className="px-4 py-3">Action</th><th className="px-4 py-3">Detail</th><th className="px-4 py-3">IP</th></tr>
          </thead>
          <tbody>
            {data.items.map((a) => (
              <tr key={a.id} className={`border-t border-slate-100 ${ALERT.includes(a.action) ? "bg-red-50/60" : ""}`} data-testid={`audit-row-${a.id}`}>
                <td className="px-4 py-2.5 whitespace-nowrap">{dt(a.ts)}</td>
                <td className="px-4 py-2.5">{a.user_name}</td>
                <td className="px-4 py-2.5">{ROLE_LABEL[a.role] || a.role}</td>
                <td className={`px-4 py-2.5 font-semibold ${ALERT.includes(a.action) ? "text-[#D9232A]" : ""}`}>{a.action}</td>
                <td className="px-4 py-2.5 max-w-[480px] break-words">{a.details}</td>
                <td className="px-4 py-2.5 text-slate-500">{a.ip}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Pager page={data.page} pages={data.pages} total={data.total} onPage={setPage} />
    </div>
  );
}
